import { useState } from "react";
import { Link, Outlet } from "react-router-dom";

const Leadership = () => {
  const [index, setIndex] = useState(0);

  return (
    <div className='leadership-container'>
      <ul id='leadershipNav'>
        <Link
          to='board-of-directors'
          onClick={() => {
            setIndex(0);
          }}
        >
          <li className={`list-item ${index === 0 ? "active" : ""}`}>
            Board of Directors
          </li>
        </Link>
        <Link
          to='management'
          onClick={() => {
            setIndex(1);
          }}
        >
          <li className={`list-item ${index === 1 ? "active" : ""}`}>
            Management
          </li>
        </Link>
      </ul>
      <div className='description'>
        <Outlet />
      </div>
    </div>
  );
};

export default Leadership;
